import React, { useState } from 'react';
import { Tabs } from '@decub8/ui';
import { GetServerSideProps } from 'next';
import Link from 'next/link';

import { Content, Meta, StakingAnalytics, StakingPools } from '@src/components';
import { CONTENT, USES_LEGACY_STAKING } from '@src/config';
import { useContent } from '@src/hooks/useContent';
import { ContentSectionType } from '@src/ts/constants';
import { IContentSection } from '@src/ts/interfaces';
import { getContentSection } from '@src/utils/getters';

const options = [
    { title: 'Staking', id: 'staking' },
    { title: 'Legacy staking', id: 'legacy-staking' },
];

const Staking: React.FC<{ staking_content_section: IContentSection }> = ({
    staking_content_section,
}) => {
    const [nav, setNav] = useState(options[0].id);
    const { stakingBanner } = useContent();

    const is_legacy = nav === options[1].id;

    const banner_url = staking_content_section?.data?.find(
        ({ key }) => key === 'banner_url',
    )?.value;

    const desktop_image = staking_content_section?.images?.find(
        ({ name }) => name === 'desktop_image',
    )?.url;

    const mobile_image = staking_content_section?.images?.find(
        ({ name }) => name === 'mobile_image',
    )?.url;

    return (
        <div className={`pt-5`}>
            <Meta title="Staking" />
            <Content>
                {USES_LEGACY_STAKING && (
                    <div className="flex justify-center w-full mt-[12px]">
                        <div className="w-80">
                            <Tabs
                                current={nav}
                                setCurrent={(id) => setNav(id)}
                                options={options}
                            />
                        </div>
                    </div>
                )}
                {/* TODO | Add staking-content-sections to the database for each
                TODO | client, then remove the stakingbanner stuff from the
                TODO | env, this will make it so these can all be updated //
                TODO | from wiithing the inn hub and will clean up the env */}
                {staking_content_section ? (
                    <div className="rounded-lg mb-5 mt-8 mx-auto">
                        <Link href={banner_url} target="_blank">
                            <img
                                src={desktop_image}
                                alt={CONTENT.companyName}
                                className="hidden md:inline w-full rounded"
                            />
                            <img
                                src={mobile_image}
                                alt={CONTENT.companyName}
                                className="md:hidden w-full rounded"
                            />
                        </Link>
                    </div>
                ) : (
                    // TODO | Remove this once the staking-content-sections are
                    // TODO | added to the database
                    <div className="rounded-lg mb-5 mt-8 mx-auto">
                        <Link href={stakingBanner?.link} target="_blank">
                            <img
                                src={stakingBanner?.desktop}
                                alt={CONTENT.companyName}
                                className="hidden md:inline w-full rounded"
                            />
                            <img
                                src={stakingBanner?.mobile}
                                alt={CONTENT.companyName}
                                className="md:hidden w-full rounded"
                            />
                        </Link>
                    </div>
                )}
                <StakingAnalytics is_legacy={is_legacy} />
                <StakingPools is_legacy={is_legacy} />
            </Content>
        </div>
    );
};

export const getServerSideProps: GetServerSideProps = async () => {
    try {
        const staking_content_section = await getContentSection(
            ContentSectionType.StakingSection,
        );

        return {
            props: {
                errors: [],
                staking_content_section,
            },
        };
    } catch (e) {
        return {
            props: {
                errors: [e.message],
            },
        };
    }
};

export default Staking;
